import { IconProps } from "models"
import { ICON_DEFAULT_SIZE } from "utils/constants"

const BackIcon: React.FC<IconProps> = ({
	className = "",
	style = null,
	color = "currentColor",
	size = ICON_DEFAULT_SIZE,
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 612 612"
			className={className}
			style={style}
			aria-hidden="true"
		>
			<path
				fill={color}
				d="M439.875 286.875H237.418l78.813-78.814c7.479-7.478 7.479-19.584 0-27.043-7.478-7.478-19.583-7.478-27.042 0l-108.19 108.19c-4.571 4.571-6.005 10.863-4.954 16.792-1.052 5.929.383 12.221 4.973 16.811l108.19 108.19c7.478 7.478 19.584 7.478 27.043 0 7.478-7.478 7.478-19.584 0-27.043l-78.833-78.833h202.457c10.557 0 19.125-8.568 19.125-19.125s-8.568-19.125-19.125-19.125zM306 0C136.992 0 0 136.992 0 306c0 168.988 136.992 306 306 306s306-137.012 306-306C612 136.992 475.008 0 306 0zm0 573.75C158.125 573.75 38.25 453.875 38.25 306S158.125 38.25 306 38.25 573.75 158.125 573.75 306 453.875 573.75 306 573.75z"
			/>
		</svg>
	)
}

export default BackIcon
